export const ORDER_FULFILLMENT_ENDPOINT = {
  CHANGE_ORDER_STATUS: '/order/orderState',
  ORDER_SUBSCRIPTION: '/tenant/orderSubscription'
};
